<template>
  <v-card    
    class="elevation-0"
    tile
    flat
    :width="getIsMobile ? '270' : '340'"    
  >
    <v-card-text class="pt-0 pb-0">
      
        <v-card flat :width="getIsMobile ? '224' : '250'">
        
           <v-row>
        <v-col cols="12" class="ma-1">
          <!--<v-autocomplete
            variant="solo"
            v-model="values"
            :items="items"
            label="Default"
            density="compact"
          ></v-autocomplete>-->
        </v-col>
        </v-row> 
        
          <v-row align="center">
            <v-col cols="12" class="pt-5 pb-0  ml-1 pr-12" >
              <v-autocomplete
                variant="solo"                
                density="compact"
                v-model="selectedBuilding"
                v-on:click="selectedBuilding = null"
                v-on:focus="selectedBuilding = null"
                @keyup.enter="directEnter"
                :items="getBuildingFeatures"
                label="Select Building"
                hide-no-data
               
                color="grey darken-1"
              >
                <template v-slot:selection="data">
                  <v-list-item-avatar
                    dark
                    tile
                    color="grey darken-1"
                    style="color: white"
                    >{{ data.item["Buildings.SpaceNumLetter"] }}
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="data.item['Buildings.Name']"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      v-html="data.item['Buildings.Address']"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </template>

                <template v-slot:item="data">
                  <v-list-item-avatar
                    dark
                    tile
                    color="grey darken-1"
                    style="color: white"
                    >{{ data.item["Buildings.SpaceNumLetter"] }}
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="data.item['Buildings.Name']"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      v-html="data.item['Buildings.Address']"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row
            ><v-col cols="12"  class="pt-2 pb-0  ml-1 pr-12">
              <v-autocomplete
                variant="solo"                
                density="compact"
                dense
                autocomplete
                color="grey darken-1"
                v-model="selectedRoom"
                label="Select Room"
                ref="selectRoom"
                :items="getRoomNumbers"
                :disabled="getRoomNumbers.length == 0"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="mt-0"
            ><v-col class="pt-0 pb-1 red--text">{{
              getRoomMessage
            }}</v-col></v-row
          >
        </v-card>

        <v-divider
          v-if="!getIsMobile"
          dark
          class="dividerClass2"
          vertical
        ></v-divider>
      
    </v-card-text>
    <!-- <v-card-actions class="pt-0">
      <v-spacer></v-spacer>
      <v-btn
        small
        color="primary"
        ref="clearBtn"
        @click="
          selectedBuilding = null;
          selectedRoom = null;
          search.clearSearch();
          search.clearURL();
        "
      >
        clear
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions> -->
  </v-card>
</template>   

<script>
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    // activeTab: "tab1",
  }),

  watch: {},
  computed: {
    ...mapState({
      stateActiveTab: "activeTab",
      stateTestString: "testString",
    }),
    ...mapGetters({
      getIsMobile: "getIsMobile",
      getRoomNumbers: "getRoomNumbers",
    }),

    selectedBuilding: {
      get() {
        return this.stateActiveTab;
      },
      set(value) {
        console.log("Value::", val);
        
        /*
        if (val) {
          this.setSelectIntRm("");
          this.setRouterRoomString("");
          let newURL = window.location.origin + this.shareParm + "/" + val;
          //  console.log("newURL::", newURL, " shareParm:: "+this.shareParm );
          window.history.pushState("object or string", "Page Title", newURL);
          this.search.highlightBuilding(val);
          this.search.loadRooms(val).then((t) => {
            console.log("done loading roos:", t);
          });
          // console.log("update focus to the building::")
          setTimeout(() => {
            let selectRoomBtn = this.$refs.selectRoom;
            selectRoomBtn.focus();
            selectRoomBtn.activateMenu();
          }, 1200);
        } else {
          this.search.clearSearch();
        }
        this.setSelectIntBldg(val);
        */
      },


    },
  },
};
</script>

<style scoped>
</style>